import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { useIsAuthenticated } from '@/hooks/redux';
// import { ThemeSwitcher } from '@/components/common/ThemeSwitcher';

export function AuthLayout() {
  // const isAuthenticated = useIsAuthenticated();
  // const transactionCode = localStorage.getItem('transactionCode');

  // Redirect to dashboard if already authenticated
  // if (isAuthenticated && transactionCode) {
  //   return <Navigate to="/transaction-code" replace />;
  // } else if (isAuthenticated && !transactionCode) {
  //   return <Navigate to="/dashboard" replace />;
  // }

  return (
    <>
      <div className="min-h-screen bg-black text-white relative flex flex-col p-5">
        {/* Logo */}

        {/* Centered Section */}
        <div className="flex-grow flex items-center relative z-40">
          <div className="relative max-w-[560px] w-full mx-auto flex-center">
            <Outlet />
          </div>
        </div>
      </div>
    </>
  );
}
